eshopApp.controller('RegisterAndContinueController', ['$scope', '$http', '$rootScope', function($scope, $http, $rootScope){
	
    $rootScope.m_RegisterAndContinue = true;

    // Emit showQuickRegister event via rootsScope
    $scope.registerAndContinue = function() {
        $rootScope.$emit('showQuickRegister', 'registered');  
        $rootScope.m_RegisterAndContinue = false;
        $rootScope.m_ContinueWithoutRegistering = false;
    }
    
}]);